// extracted by mini-css-extract-plugin
export default {"ActionWrapper":"DataTable_ActionWrapper__QGN5Q","lastRow":"DataTable_lastRow__6bXk0"};